export const CRM_TYPES = {
  mt: 'mt',
  tat: 'tat',
  '5stars': '5stars',
  easybooking: 'easybooking',
  nakanikuly: 'nakanikuly',
  multitour: 'multitour',
};
